export default __webpack_public_path__ + "883d7fb3b593be14ac6884e666fc731a.svg";